import { Component, Input, NgModuleRef, OnInit } from '@angular/core';
import { GroupClassDetailsModel, GroupClassParticipantsModel } from '@bayclubs/group-classes-employee-api';
import { HorizonToastService } from '@bayclubs/horizon';
import { ModalService } from '@bayclubs/utils';
import { TranslateService } from '@ngx-translate/core';
import { gcManagementEnumerations } from '../../../../interfaces/interfaces.module';
import { AddParticipantComponent } from '../add-participant/add-participant.component';

@Component({
    selector: 'app-group-classes-add-participants',
    templateUrl: './group-classes-add-participants.component.html',
    styleUrls: ['./group-classes-add-participants.component.scss'],
    standalone: false
})
export class GroupClassesAddParticipantsComponent implements OnInit {
    @Input()
    public model: GroupClassDetailsModel;
    @Input()
    public attendance: GroupClassParticipantsModel;

    constructor(
        private modalService: ModalService,
        private toast: HorizonToastService,
        private translateService: TranslateService,
        private moduleRef: NgModuleRef<any>
    ) {}

    ngOnInit() {}

    public addParticipant() {
        if (this.canBook()) {
            this.showAddParticipantModal();
        } else {
            this.showCannotBookClassError();
        }
    }

    private canBook(): boolean {
        let canBook = true;
        if (this.model.isBookingRequired === true) {
            if (this.model.isBookingRequiresSpecificResource === true) {
                canBook = this.model.location.numberOfResources > this.getActiveAttendanceCount();
            } else {
                canBook = this.model.capacity > 0 && this.model.capacity > this.getActiveAttendanceCount();
            }
        }

        return canBook;
    }

    private getActiveAttendanceCount(): number {
        return this.attendance.items.filter(x => x.status.code === gcManagementEnumerations.GroupClassStatus.active.code)
            .length;
    }

    private showAddParticipantModal() {
        const params = {
            model: this.model
        };

        this.modalService
            .create<AddParticipantComponent>(AddParticipantComponent, params, this.moduleRef)
            .subscribe(value => {});
    }

    private showCannotBookClassError() {
        this.toast.error(this.translateService.instant('GroupClassDetails.ClassIsFullyBookedMessage'));
    }
}
